import React from 'react'
import Link from 'next/link'
import { AppRoute } from '@chegg-wt/core/types/core'
import { isWebRoute, routeToHref } from '@chegg-wt/core/utils/routes'

export const AppLink: React.FC<{ route: AppRoute; replace?: boolean }> = ({
  route,
  children,
  replace,
}) => {
  if (isWebRoute(route)) {
    return (
      <>
        {React.Children.map(children, (child) => {
          if (React.isValidElement(child)) {
            return React.cloneElement(child, { ...child.props, href: routeToHref(route) })
          }
          return child
        })}
      </>
    )
  }
  return (
    <Link {...route} passHref replace={replace}>
      {children}
    </Link>
  )
}

export default AppLink
